'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    // Init
    var elementsCollection = document.querySelectorAll("li[data-catalog-products]");

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop2 = function _loop2() {
            var catalogLi = _step.value;

            catalogId = getCatalogId(catalogLi);
            catalogLi.dataset.catalogId = catalogId;

            catalogLi.addEventListener("click", function () {
                catalogClick(catalogLi);
            });
        };

        for (var _iterator = (0, _getIterator3.default)(elementsCollection), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop2();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (elementsCollection && elementsCollection.length > 0) {
        catalogSettings = loadSettings();
        window.addEventListener("scroll", userScroll);
        loadCatalogByUrl();
    }

    function loadCatalogByUrl() {
        var catalogIdFromUrl = _utils2.default.getQueryStringParam('catalogId');
        if (!catalogIdFromUrl) return;

        var catalogLi = document.querySelector('#catalogNav li[data-catalog-id="' + catalogIdFromUrl + '"]');
        if (!catalogLi) return;

        catalogClick(catalogLi);
        var filterElement = catalogLi.closest('.filter');
        if (!filterElement) return;

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(filterElement.querySelectorAll('.filter__header.closed')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var closedElement = _step2.value;

                closedElement.classList.remove('closed');
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var catalogElWrapper = filterElement.querySelector('.filter__content');
        if (!!catalogElWrapper) {
            catalogElWrapper.style.display = 'block';
        }
    }

    function loadSettings() {
        var dummySettings = { catalogPageSize: 50 };
        try {
            var catalogSettingsElement = document.getElementById('catalogSettings');
            return catalogSettingsElement ? JSON.parse(catalogSettingsElement.value) : dummySettings;
        } catch (e) {
            console.warn('Settings is not available', e);
            return dummySettings;
        }
    }

    function userScroll() {
        if (isLoading || pageNumber > pageCount) return;

        var lastItem = document.querySelector('.table-view--title-name:last-child');
        if (!lastItem) return;

        var lastItemTopPosition = lastItem.getBoundingClientRect().top;

        if (lastItemTopPosition < window.innerHeight && productIds.length > catalogSettings.catalogPageSize) {
            isLoading = true;
            pageNumber++;
            updateCatalogItems();
        }
    }

    function getCatalogId(catalogLi) {
        try {
            return (/^[1-9][0-9]{0,15}$/.test(catalogLi.dataset.catalogId) ? parseInt(catalogLi.dataset.catalogId) : -1
            );
        } catch (e) {
            console.error('Error parsing catalog Id from li element.', catalogLi, e);
        }
    }

    function catalogClick(catalogLi) {
        try {
            isLoading = true;
            cartAppenders = [];
            catalogId = getCatalogId(catalogLi);

            // remove selected class from all catalog li elements and then set current one 
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(document.querySelectorAll('.filter .arrow-item')), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var li = _step3.value;

                    li.classList.remove(selectedCatalogCssClass);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            catalogLi.classList.add(selectedCatalogCssClass);

            var catalogPane = document.querySelector('.catalog-pane');
            if (catalogPane) catalogPane.classList.remove('invisible-catalog');

            var initialTextElement = document.querySelector('.initial-catalog-text');
            if (initialTextElement) initialTextElement.classList.add('invisible-catalog');

            var catalogItemNameEl = catalogLi.querySelector(".catalog-name");
            var catalogTitle = document.getElementById('catalogTitle');

            if (catalogItemNameEl && catalogTitle) catalogTitle.textContent = catalogItemNameEl.textContent;else console.warn('Element of li with class catalog-name or element with id = catalogTitle  is not present on the page');

            if (!catalogLi.dataset.catalogProducts) {
                console.warn('Catalog products data array is null.');
                return;
            }

            history.pushState({ catalogId: catalogId, catalogTitle: 'catalogTitle.textContent' }, 'catalogId:' + catalogId, '?catalogId=' + catalogId);

            catalogProductsObject = JSON.parse(catalogLi.dataset.catalogProducts);
            productIds = _Common2.default.sortByStringParam(catalogProductsObject, 'Name').map(function (p) {
                return p.Id;
            });
            pageCount = Math.ceil(productIds.length / catalogSettings.catalogPageSize);
            pageNumber = 1;
            updateCatalogItems();
        } catch (e) {
            console.error(e);
        }
    }

    function updateCatalogItems() {
        var pageStart = (pageNumber - 1) * catalogSettings.catalogPageSize;
        var pageEnd = pageNumber * catalogSettings.catalogPageSize;

        // take only results for one page
        var pagedProductIds = productIds.length <= catalogSettings.catalogPageSize ? productIds : productIds.slice(pageStart, pageEnd);

        // do not request those, which are in cache
        catalogAllProductsCached = _storageProvider2.default.getValue(catalogItemsCacheKey) || [];
        var catalogCacheHasValues = catalogAllProductsCached && catalogAllProductsCached.length > 0;
        if (catalogCacheHasValues) {
            // find items, which are not in cache (pagedProductIds)
            cachedProductsCurrentPage = catalogAllProductsCached.filter(function (c) {
                return pagedProductIds.indexOf(c.id) > -1;
            });
            var cachedProductIds = cachedProductsCurrentPage.map(function (m) {
                return m.id;
            });
            pagedProductIds = pagedProductIds.filter(function (p) {
                return cachedProductIds.indexOf(p) < 0;
            });
        }
        showHideLoading(false);

        if (pagedProductIds.length < 1 && catalogCacheHasValues) {
            fillTableData(cachedProductsCurrentPage);
        } else {
            // server callback
            catalogService.getCatalogItemsByIds(pagedProductIds, null).done(processServerCatalogData).fail(function (result) {
                console.error('Error in calling endpoint catalogService.getCatalogItemsByIds', result);
            });
        }
    }

    function showHideLoading(hide) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = (0, _getIterator3.default)(document.getElementsByClassName('loading-animation')), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var loadingElement = _step4.value;

                loadingElement.style.display = hide ? '' : 'block';
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }

    function processServerCatalogData(catalogData) {
        var catalogDataMerged = catalogData.concat(cachedProductsCurrentPage);

        // update cache 
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            var _loop = function _loop() {
                var item = _step5.value;

                var cachedItem = catalogAllProductsCached.find(function (c) {
                    return c.id === item.id;
                });
                if (cachedItem) cachedItem = item;else catalogAllProductsCached.push(item);
            };

            for (var _iterator5 = (0, _getIterator3.default)(catalogData), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        _storageProvider2.default.setValue(catalogItemsCacheKey, catalogAllProductsCached);

        // rebuild table
        fillTableData(catalogDataMerged);
    }

    function fillTableData(catalogProductsObject) {
        showHideLoading(true);
        var catalogBodyElement = document.getElementById("catalogBody");
        if (!catalogBodyElement) {
            console.warn("Element catalogBody is not present on the page");
            return;
        }
        // clear space for new data
        if (pageNumber === 1) catalogBodyElement.innerHTML = '';
        var cartData = _Common2.default.getCartData();

        currentPageData = _Common2.default.sortByStringParam(catalogProductsObject, 'name');
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = (0, _getIterator3.default)(currentPageData), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var product = _step6.value;

                try {
                    // Create Row 
                    var rowClass = 'product-row table-view--title-name ' + (!product.canPurchase ? "not-available" : "");
                    var productRow = _Common2.default.createElement('tr', catalogBodyElement, { className: rowClass });

                    // Product Name
                    createNameCell(productRow, product);

                    // Product Type
                    createProductTypeCell(product, productRow);

                    var pricesSettings = _linksoftAlbatros.settings.get().prices || { defaultDecimals: 2, decimals: { catalogUnitPrice: 2 } };
                    var decimalPlaces = (pricesSettings.decimals || {}).catalogUnitPrice;
                    if (decimalPlaces === null || decimalPlaces === undefined) decimalPlaces = pricesSettings.defaultDecimals;
                    // Retail price - SK only
                    if (catalogSettings.isSkEnvironment) {
                        var retailPriceString = (product.retailPrice || 0).toFixed(decimalPlaces) + '&nbsp;' + Resx.App.Currency;
                        _Common2.default.createElement('td', productRow, { className: 'price', innerHTML: retailPriceString });
                    }
                    //Price
                    var priceString = ((product.resultPrice || {}).standardPrice || 0).toFixed(decimalPlaces) + '&nbsp;' + Resx.App.Currency;
                    _Common2.default.createElement('td', productRow, { innerHTML: priceString, className: 'price' });

                    // Amount
                    createAmountCell(productRow, product, cartData);
                } catch (e) {
                    console.warn('Unable to bind product: \'' + product.name + '\', Id: ' + product.id + '.', e);
                }
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        isLoading = false;
    }

    function createNameCell(productRow, product) {
        var nameColumn = _Common2.default.createElement('td', productRow);
        var nameLink = _Common2.default.createElement('a', nameColumn, {
            textContent: product.name,
            href: '#',
            className: 'product-title '
        });
        nameLink.dataset.previewDetail = product.id;

        if (product.isInMoreThenOneCatalogue) {
            var moreCatalogsIcon = _Common2.default.createElement('i', nameColumn, { className: "icon--multiple" });
            (0, _assign2.default)(moreCatalogsIcon.dataset, {
                toggle: "tooltip",
                container: "body",
                originalTitle: Resx.App.IsInMoreThenOneCatalogue
            });
        }
    }

    function createProductTypeCell(product, productRow) {
        // kind of stupid, but I just reimplemented it not invented :) 
        var productTypeName = product.productType.name.toLowerCase();
        var isBook = productTypeName.indexOf('kniha') > -1;
        var isAudio = productTypeName.indexOf('audio') > -1;
        var productTypeClass = product.isProductBundle ? "icon--book-package" : isAudio && !isBook ? "icon--head-phone" : "icon--book";
        var typeColumn = _Common2.default.createElement('td', productRow, { className: productTypeClass });
        (0, _assign2.default)(typeColumn.dataset, {
            toggle: "tooltip",
            container: "body",
            originalTitle: product.productType.name
        });
    }

    function createAmountCell(productRow, product, cartData) {
        if (!product.canPurchase) {
            _Common2.default.createElement('td', productRow, {
                className: 'text-right red',
                textContent: Resx.App.ProductUnsaleable
            });
            return;
        }

        var amountCell = _Common2.default.createElement('td', productRow, { className: 'amount-cell' });
        var amount = '';
        if (cartData) {
            var _item = cartData.items.find(function (i) {
                return i.id === product.id;
            });
            if (_item) {
                amount = _item.amount;
            }
        }
        cartAppenders.push(new _cartAppender2.default(amountCell, product.id, amount, currentPageData, catalogId));
    }
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _Common = require('../modules/Common');

var _Common2 = _interopRequireDefault(_Common);

var _storageProvider = require('../modules/storageProvider');

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _linksoftAlbatros = require('linksoft-albatros');

var _cartAppender = require('../modules/cartAppender');

var _cartAppender2 = _interopRequireDefault(_cartAppender);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var catalogService = abp.services.api.catalog;
var Resx = (0, _localize2.default)('Common', 'App', 'DataTables');
var catalogProductsObject = [];
var productIds = [];
var currentPageData = [];
var catalogAllProductsCached = [];
var cachedProductsCurrentPage = [];
var catalogItemsCacheKey = 'catalogItemsCache';
var catalogId = -1;
var cartAppenders = [];
var pageNumber = 1;
var pageCount = 0;
var catalogSettings = {};
var isLoading = false;
var selectedCatalogCssClass = 'active';

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/catalogLoader.js
// module id = 1167
// module chunks = 0